import { useTranslations } from 'next-intl'

import {
  AdditionalOption,
  BasicOption,
  OldAdditionalOption,
  TRoomDetail,
} from '@/entities/room'

export const OPTION_DISPLAY_LIMIT = 9

type Params = Pick<TRoomDetail, 'basicOptions' | 'missingOptions'> & {
  additionalOptions: (AdditionalOption | OldAdditionalOption)[]
}

export const getOptionData = ({
  basicOptions,
  additionalOptions,
}: Pick<Params, 'basicOptions' | 'additionalOptions'>) => ({
  slicedOptions: additionalOptions.slice(0, OPTION_DISPLAY_LIMIT),
  totalCount: basicOptions.length + additionalOptions.length,
  hasBasicOptions: basicOptions.length > 0,
  hasAdditionalOptions: additionalOptions.length > 0,
})

type OptionList = {
  key: string
  title: string
  options: BasicOption[] | AdditionalOption[]
}

export const useOptionList = ({
  basicOptions,
  additionalOptions,
  missingOptions,
}: Params): OptionList[] => {
  const t = useTranslations('room_detail')

  const hasBasicOptions = basicOptions.length > 0
  const hasAdditionalOptions = additionalOptions.length > 0
  const hasMissingOptions = missingOptions.length > 0

  return [
    hasBasicOptions && {
      key: 'basicOptions',
      title: t('basic_option.title'),
      options: basicOptions,
    },
    hasAdditionalOptions && {
      key: 'additionalOptions',
      title: t('additional_option.title'),
      options: additionalOptions,
    },
    hasMissingOptions && {
      key: 'missingOptions',
      title: t('option.modal.not_include_option'),
      options: missingOptions,
    },
  ].filter(Boolean) as OptionList[]
}
